// import Loader from "@Common/Loader";

import { inject, observer } from "mobx-react";
import { useEffect } from "react";

import "./style.scss";

const CPCModal = inject("mainStore")(
    observer(({ mainStore, modal }) => {
        // const abTest = mainStore.getMainStore("abTest");
        // const abTestMetika = mainStore.getMainStore("abTestMetika");
        const regionId = mainStore.getMainStore("promoIdRegion");
        const cityId = mainStore.getMainStore("promoIdCity");
        const metroId = mainStore.getMainStore("promoIdMetro");
        const cap_token = mainStore.getMainStore("capToken"); // забираем полученный токен при включении формы

        const { offerItem } = modal;

        useEffect(() => {
            (async () => {
                // await delay(2000);
                const hrefOut = offerItem.activationLink;
                const a = document.createElement("a");
                a.href = hrefOut;
                a.target = "_blank";
                a.click();
                a.remove();

                if (!offerItem.promoCode) {
                    const resp = await mainStore.getByUrl("app_rispromo/get_promo", { offerId: offerItem._id, cap_token, regionId, cityId, metroId }, false, "", false);
                    if (resp?.success) {
                        mainStore.setMainStore("promoIdCity", false);
                        mainStore.setMainStore("promoIdRegion", false);
                        mainStore.setMainStore("promoIdMetro", false);
                        mainStore.addPromoToOffer(resp.data);

                        mainStore.getByUrl("/app_rispromo/offers_list", "", false, "offersList");
                    }
                }
                mainStore.setMainStore("capToken", "qwerty");
                mainStore.setMainStore("modal", false);
            })();
        }, []);

        return (
            <div></div>
            // <div className="cpc-modal">
            //     <Loader />
            //     <span className="cpc-modal__text">{offerItem?.offerDetail?.ordRisPromo}</span>
            // </div>
        );
    }),
);

export default CPCModal;
